<template>
  <div class="layout-col white-space-normal ">
    <section class="-wrapper-tile -wrapper-column -h-center- -height-100">
      <div class="-header between- -pl-4 -pr-2">
        <p class="-h2 -font-weight-regular">
          Asset Management
        </p>
        <g-button id="dashboard-service-card1-open" variant="borderless" size="small" class="-px-1 -mr-0" @click="goToService">
          <g-icon name="navigate_next"></g-icon>
        </g-button>
      </div>
      <div class="-width-100 -pb-5">
        <g-tab
          :value="0"
          :tabNames='["tab-1","tab-2","tab-3"]'
          :small="false"
          :selected="null"
          :input="null"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    goToService () {
      console.log('Go to Service')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/home/components/ServiceCard.vue